import { useQuery } from "@apollo/client";
import Errors from "components/base/Errors";
import Spinner from "components/base/Spinner";
import { FETCH_STOCK_CHECK_ALC_STOCKS } from "../../graphql";
import StockCompareView from "./StockCompareView";

const StockCompareViewLoader = ({ stockCategoryId, onSelect }) => {
  const { loading, error, data } = useQuery(FETCH_STOCK_CHECK_ALC_STOCKS, {
    variables: { stockCategoryId },
    fetchPolicy: "network-only",
  });

  if (loading) return <Spinner />;
  if (error) return <Errors error={error} />;

  return (
    <StockCompareView
      stocks={JSON.parse(data.stockCheckAlcStocks).results}
      onSelect={onSelect}
    />
  );
};

export default StockCompareViewLoader;
